export default {
  'header': {
    'createtournament': 'Создать турнир',
    'registrationLogin': 'Войти',
    'join': 'Присоединиться',
    'login': 'Войти',
    'profile': 'Профиль',
    'historyOfTournaments': 'История турниров',
    'subscriptionDepositWithdrawal': 'Подписка',
    'transactionHistory': 'История транзакций',
    'logOutOfYourAccount': 'Выйти из аккаунта',
    'referralProgramSocialNetworks': 'Реферальная программа',
    'games': 'Игры',
    'media': 'Медиа',
    'tariffs': 'Тарифы',
    'about': 'О проекте'
  },
  'button': {
    'createTournament': 'Создать турнир',
    'create': 'Создать'
  },
  'auth': {
    'logIn': 'Войти',
    'register': 'Регистрация',
    'login': 'Логин*',
    'password': 'Пароль*',
    'rememberMe': 'Запомнить меня',
    'forgotYourPassword': 'Забыли пароль?',
    'repeatPassword': 'Повторите пароль*',
    'email': 'Почта*',
    'month': 'Месяц',
    'day': 'День',
    'year': 'Год',
    'signUp': 'Зарегистрироваться',
    'youMustBeToRegister': 'Вам должно быть 13+ для регистрации*',
    'successRegister': 'На почту {mail} отправлено письмо с инструкцией по активации вашего аккаунта',
    'successfulLogout': 'Успешный выход из системы',
    'confirmationTextMessageWasSentToYourEmail': 'На вашу почту выслано смс с подтверждением',
    'congratulations': 'ПОЗДРАВЛЯЕМ',
    'congratsText': 'с успешной регистрацией на Cyber Fight Tournaments! \r\n Чтобы пользоваться всеми преимуществами нашего портала, мы рекомендуем подключить ваши игровые аккаунты в личном кабинете.',
    'sendCode': 'Отправить код',
    'checkYourEmail': 'Проверьте вашу почту',
    'changePassword': 'Сменить пароль',
    'oldPassword': 'Старый пароль',
    'newPassword': 'Новый пароль',
    'confirmNewPassword': 'Подтверждение',
    'confirmPasswordChange': 'Подтвердить',
    'backToMain': 'Вернуться на главную'
  },
  'general': {
    'noMatch': 'нет подходящих вариантов',
    'success': 'Операция успешна',
    'error': 'Ошибка',
    'warning': 'Внимание!',
    'great': 'Отлично',
    'gotIt': 'Понятно',
    'more': 'Подробнее',
    'join': 'Участвовать',
    'save': 'Сохранить',
    'pageNotFound': 'Упс... страница не найдена',
    'change': 'Поменять'
  },
  'errors': {
    'required': 'Обязятельно для заполнения',
    'emailError': 'Hе верный формат Email',
    'numeric': 'Hе верный формат',
    'notEqualPasswords': 'Пароли не совпадают',
    'minLength': 'Минимальная длина {n}',
    'maxLength': 'Максимальная длина {n}',
    'isUsername': 'Допустимые символы a-z, A-Z, 0-9, _',
    'minValue': 'Минимум {n}',
    'maxValue': 'Максимум {n}'
  },
  'mainPage': {
    'gameChoice': 'Выбор игры',
    'selectPlatform': 'Выбор платформы',
    'noTournaments': 'Упс... сейчас нет турниров',
    'tournamentName': 'Название турнира',
    'numberOfPlayers': 'Кол-во игроков (макс.{max})',
    'indiv': 'СОЛО',
    'team': 'Команда',
    'ticket': 'Билет*',
    'dateAndTime': 'Дата и время*',
    'hour': 'Час*',
    'minute': 'Минута*',
    'prizeFund': 'Призовой фонд',
    'currentPrizeFund': 'Текущий призовой фонд',
    'maximumPrizeFund': 'Максимальный призовой фонд',
    'maximumPrizeFund*': 'Максимальный призовой фонд*',
    'free': 'Бесплатный',
    'prem': 'Премиум',
    'notSelected': 'Не выбрано',
    'description': 'Описание турнира'
  },
  'tournament': {
    'name': 'Название',
    'platform': 'Платформа',
    'time': 'дней | {n} день | {n} дня | {n} дней',
    'youAreInvolvedIn': 'Вы участвуете',
    'ticket': 'Билет',
    'awards': 'Награды',
    'completed': 'Завершен',
    'youTookPartInTournament': 'Вы приняли участие в турнире',
    'connectionOptions': 'Параметры подключения',
    'howToConnect': 'Как подключиться?',
    'tournamentDescription': 'Описание турнира',
    'participants': 'Участники',
    'from': 'из',
    'positionInTable': 'Положение в таблице',
    'chooseWinnerOrLoser': 'Выберите кем вы являетесь - победителем или проигравшим, и загрузите скриншот итоговой таблицы турнира для модерации.',
    'winner': 'Победитель',
    'loser': 'Проигравший',
    'downloadScreenshotOfTheSummaryTable': 'Загрузите скриншот итоговой таблицы',
    'review': 'Обзор',
    'seatAllocation': 'Распределение мест',
    'place': '({n} местo)',
    'listOfParticipantsEmpty': 'Список участников пуст',
    'listOfAwardsEmpty': 'Список наград пуст'
  },
  'profile': {
    'nonActive': 'Неактивна',
    'edit': 'Редактировать профиль',
    'changeAvatar': 'Сменить аватар',
    'randomAvatar': 'Рандомный аватар',
    'matches': 'Сыграно матчей',
    'wins': 'Одержано побед',
    'referrals': 'Рефералов',
    'login': 'Логин*',
    'nickname': 'Никнейм*',
    'email': 'Почта*',
    'changeEmail': 'Сменить почту',
    'changePassword': 'Смена пароля',
    'currentPassword': 'Текущий пароль*',
    'newPassword': 'Новый пароль*',
    'repeatPassword': 'Повторите новый пароль*',
    'nicknames': 'Никнеймы в играх',
    'gameChoice': 'Выбор игры',
    'save': 'Сохранить изменения',

    'tournamentName': 'Название турнира',
    'tournamentDate': 'Дата турнира',
    'tournamentPlace': 'Место',
    'tournamentReward': 'Награда',
    'tournamentPerPage': 'Турниров на странице',
    'from': 'из',

    'subscription': 'Подписка',
    'deposit': 'Депозит',
    'derivation': 'Вывод',
    'exchange': 'Обмен',
    'basic': 'Базовая',
    'premium': 'Премиум',
    'subscribe': 'Подписаться',
    // 'basicPoint1': 'Участие в общих турнирах',
    // 'basicPoint2': 'Участие в спонсорских турнирах',
    // 'basicPoint3': 'Создание своих собственных турниров!',
    // 'premiumPoint1': 'Все возможности Базовой подписки',
    // 'premiumPoint2': 'Участие в спонсорских турнирах',
    // 'premiumPoint3': 'Создание своих собственных турниров!',
    'bonus': 'Нет бонуса | Бонус | {n} Бонуса | {n} Бонусов',
    'other': 'Другое',
    'enterTicketsQuantity': 'Введите сумму*',
    'price': 'Цена',
    'totalPrice': 'Итоговая цена',
    'ticketsQuantity': 'Количество билетов',
    'get': 'Получить',
    'withdrawnTicketsQuantity': 'Выводимая сумма*',
    'cardNumber': 'Номер карты получателя*',
    'withdraw': 'Вывести',

    'referralProgram': 'Реферальная программа',
    'referralLink': 'Реферальная ссылка',
    'copy': 'Скопировать',
    'referralTerms': 'Здесь описаны условия реферальной программы.',
    'socialLinks': 'Введите ссылки на свои социальные сети или контакты в мессенджерах, чтобы мы могли оперативно связаться с вами по техническим вопросам или по поводу выигрыша',
    'idTransaction': 'ID транзакции',
    'transactionType': 'Тип транзакции',
    'transactionDate': 'Дата транзакции',
    'currency': 'Валюта',
    'linkSuccessfullyCopied': 'Ссылка успешно скопирована',
    'noTournamentsFound': 'Турниров не найдено',
    'noTransactionsFound': 'Транзакций не найдено',
    'toPayFollowThisLink': 'Для оплаты перейдите по ссылке',
    'dataUpdatedSuccessfully': 'Данные успешно обновлены',
    'idSearch': 'ID турнира',
    'forExchange': 'На обмен:',
    'total': 'Итого:'
    // '': '',
  },
  'transactions': {
    'waitTransaction': 'Платеж обрабатывается, обычно это занимает 1-3 минуты',
    'transactionsPerPage': 'Транзакций на странице',
    'buy_in': 'Покупка',
    't_creation': 'Создание турнира',
    't_participation': 'Участие в турнире',
    't_prize': 'Приз за участие в турнире',
    't_refund': 'Возврат денег за участие в турнире',
    'withdrawal': 'Вывод средств',
    'withdrawal_refund': 'Возврат денег за вывод средств',
    'deposit_wait': 'Ожидание депозита',
    'deposit': 'Депозит',
    'deposit_bonus': 'Бонус на депозит',
    'admin_change': '',
    'user_change': 'Обмен'
  },
  'date': {
    'jan': 'Январь',
    'feb': 'Февраль',
    'mar': 'Март',
    'apr': 'Апрель',
    'may': 'Май',
    'jun': 'Июнь',
    'jul': 'Июль',
    'aug': 'Август',
    'sep': 'Сентябрь',
    'oct': 'Октябрь',
    'nov': 'Ноябрь',
    'dec': 'Декабрь'
  },
  'game': {
    'mobile': 'Мобильная',
    'pc': 'ПК',
    'ps': 'PlayStation',
    'xbox': 'Xbox'
  }
}



// WEBPACK FOOTER //
// ./src/locales/ru.js